import { Injectable } from '@angular/core';
import { agpmInitialState, AgpmStateProps, agpmStateStore } from './agpm-state.store';
import { select } from '@ngneat/elf';
import { BaseStoreRepository } from '../base-store.repository';
import { Agpm, ResponseDoc } from '@/types';

@Injectable({
  providedIn: 'root',
})
export class AgpmRepository extends BaseStoreRepository<AgpmStateProps> {
  constructor() {
    super(agpmStateStore.pipe(select(state => state)), agpmStateStore, agpmInitialState);
  }

  setResponseAndDto(response: Agpm) {
    this.set('response', response);
    this.set('dto', {
      ref: response.ref,
      nom: response.nom,
      annee: response.annee,
      acId: response.ac.id,
      contenu: response.contenu,
      remarque: response.remarque,
      files: [],
      docIds: response.docs.map(doc => doc.id),
    });
    this.set('acsSelected', { name: response.ac.nom, code: response.ac.id });
  }

  getDtoFormData(isSourceTask: boolean): FormData {
    const agpmEditFormData = new FormData();
    const docIds = this.getNested<ResponseDoc[]>('response', 'docs')?.map(doc => doc.id);
    const files = this.getNested<File[]>('dto', 'files');
    const prefix = isSourceTask ? 'agpm.' : '';
    if (this.getNested<number>('dto', 'acId') !== undefined && this.getNested<number>('dto', 'acId') !== null) {
      agpmEditFormData.append(`${prefix}acId`, this.getNested<number>('dto', 'acId').toString());
    }
    ['nom', 'contenu', 'annee', 'remarque'].forEach(key => {
      agpmEditFormData.append(`${prefix}${key}`, this.getNested<string>('dto', key));
    });
    if (docIds && docIds.length > 0) {
      agpmEditFormData.append(`${prefix}docIds`, docIds.map(doc => doc.toString()).join(','));
    }
    if (files && files.length > 0) {
      files.forEach(file => agpmEditFormData.append(`${prefix}files`, file));
    }
    return agpmEditFormData;
  }
}
